import { useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle,
  AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

export const PurgeUsersButton = ({ onDone }) => {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  const purge = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/users/purge", { confirm: "APAGAR" });
      toast.success(`${data.deleted} contas apagadas`);
      setOpen(false);
      setText("");
      onDone?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erro ao apagar");
    } finally { setBusy(false); }
  };

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger asChild>
        <button data-testid="purge-users-btn" className="brutal-btn brutal-btn-outline text-sm inline-flex items-center gap-2" style={{ borderColor: "#FF0055", color: "#FF0055" }}>
          <Trash2 size={16} /> Apagar todas as contas
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent data-testid="purge-users-dialog" className="bg-[#0A0A0A] border-[#FF0055] text-white">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-bebas text-3xl tracking-tighter">Apagar todas as contas?</AlertDialogTitle>
          <AlertDialogDescription className="text-white/70 font-manrope">
            Apaga todas as contas (menos a de admin), junto com Pix, progresso e pontos do ranking. Não tem volta. Digita APAGAR pra confirmar.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <input data-testid="purge-users-input" value={text} onChange={(e) => setText(e.target.value)} placeholder="APAGAR" className="brutal-input" />
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="purge-users-cancel">Cancelar</AlertDialogCancel>
          <button data-testid="purge-users-confirm" disabled={text !== "APAGAR" || busy} onClick={purge} className="brutal-btn text-sm" style={{ background: "#FF0055", color: "#fff" }}>
            {busy ? "Apagando..." : "Apagar tudo"}
          </button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
